export enum PartnerType {
    PHYSICAL_STORE = "physical-store",
    ONLINE_STORE = "online-store",
}
